import { useContext } from "react"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"

export const useFirestoreImportHistoryUpdate = () => {
	try {
		const authenticatedFetch = useAuthenticatedFetch()
		const { state, dispatch } = useContext(GlobalStateContext)
		const shop = state.shop

		return async (fields) => {
			return await authenticatedFetch(
				"/api/firestore/addImportHistoryEntry",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						shop: shop,
						entry: fields,
					}),
				},
			).catch((err) => console.error(err))
		}
	} catch (error) {
		console.error("[useFirestoreDataUpdate] catched error", error)
	}
}
